module.exports = __webpack_public_path__ + "static/media/papillon_trade.ef9eb5ee.png";